import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Notifications from './Notifications';
//materialUI
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import MyButton from '../../util/myButton';

//icons
import PostSoundOff from '../soundOff/PostSoundOff';
import HomeIcon from '@material-ui/icons/Home';

import { connect } from 'react-redux';

//react router
const Link = require('react-router-dom').Link;

export class Navbar extends Component {
    render() {
        const { authenticated } = this.props;
        return (
            <AppBar>

                <Toolbar className='nav-container'>
                    {authenticated === false ? (
                        <React.Fragment>
                            <Button component={Link} to='/' color='inherit'>Home</Button>
                            <Button component={Link} to='/login' color='inherit'>Login</Button>
                            <Button component={Link} to='/signup' color='inherit'>Signup</Button>
                        </React.Fragment>
                    ) : (
                            <React.Fragment>
                                <PostSoundOff />
                                <Link to='/'>
                                    <MyButton
                                        tip='Home'

                                    >
                                        <HomeIcon color='primary' />
                                    </MyButton>
                                </Link>

                                <Notifications color='primary' />

                            </React.Fragment>
                        )}
                </Toolbar>

            </AppBar>
        )
    }
}


Navbar.prototypes = {
    authenticated: PropTypes.bool.isRequired
};


const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated
})

export default connect(mapStateToProps)(Navbar);
